import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  API_URL_GET_AGENDA_SOLUTIONS,
  API_URL_GET_AGENDA_NEEDS,
  API_URL_SEARCH_MY_PAGE_CHAT,
  API_URL_UPDATE_MATCH_STATUS_MY_PAGE,
  INFORMATION_LIST,
  API_URL_SEARCH_MATCHED,
  API_URL_GET_CONSULTATION
} from "manager/http-constants";
import { AuthorityDecision } from "manager/user-authority-constant";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { LoadingState } from "src/app/shared/html-parts/loading/loading-state";
import { CommonService } from "src/app/shared/service/common.service";
import { DbOperationService } from "src/app/shared/service/db-operation.service";
import { LoginService } from "src/app/shared/service/login.service";
import { ConfirmRejectMatchDialogComponent } from "../common/confirm-reject-match-dialog/confirm-reject-match-dialog.component";
import { MemoDialogComponent } from "../common/memo-dialog/memo-dialog.component";
import { PlatformComponent } from "../platform.component";
import { CHARACTER_CODE, CHATSTATUSES, MATCH_TYPE, NOTICE_TYPES, ROLES } from "src/app/shared/constant/constant";
import { forkJoin } from "rxjs";
import { ConditionalExpr } from "@angular/compiler";
import { ConsultationDialogComponent } from "../common/consultation-dialog/consultation-dialog.component";

@Component({
  selector: "app-b301",
  templateUrl: "./b301.component.html",
  styleUrls: ["./b301.component.scss", "../platform.component.scss"],
})

/**
 * マイページ
 */
export class B301Component extends PlatformComponent {
  /** 削除ダイアログ */
  @ViewChild(ConfirmRejectMatchDialogComponent)
  confirmRejectMatchDialogComponent: ConfirmRejectMatchDialogComponent;

  @ViewChild(MemoDialogComponent)
  memoDialogComponent: MemoDialogComponent;

  @ViewChild(ConsultationDialogComponent)
  consultationDialogComponent: ConsultationDialogComponent;

  // 最近の更新（最近1ヶ月）格納先
  updateDataList: object[] = new Array();

  // 事務局からのお知らせ格納先
  noticeDataList: object[] = new Array();

  // 事務局からのお知らせ格納先
  needinputList: any;

  listAgendaSolutions: object[] = new Array();
  listAgendaNeeds: object[] = new Array();
  listConsultations: object[] = new Array();
  statusValue: any[] = [];
  roleAuth: any;
  isShowDialogC331: boolean = false;
  isShowDialogC341: boolean = false;
  isShowMemoDialog: boolean = false;
  isLoading: boolean = true;
  isUnanswered: boolean = false;
  statusProgress: Object[] = [
    CHATSTATUSES.REQUEST,
    CHATSTATUSES.ADJUSTMENT,
    CHATSTATUSES.DECISION,
    CHATSTATUSES.IMPLEMENTED,
  ];
  status: Object[] = [
    CHATSTATUSES.ADJUSTMENT,
    CHATSTATUSES.END,
  ];
  checkAll: any[] = [];
  // list of chat information my page
  listChatMypage: any[] = [];
  listChatMypageNG: any[] = [];
  matchId: string;
  agendaId: string;
  listNotice: object[];
  // システムに関するお知らせ情報リスト
  platformEventDataList: object[] = new Array();
  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    public loginService: LoginService,
    private changeDetector: ChangeDetectorRef
  ) {
    super(route, commonService, dbOperationService, loadingState, loginService);
  }

  ngOnInit(): void {
    if (!this.loginUser) {
      this.loadingState.loadStart();

      this.loginService.getLoginUser().subscribe((response) => {
        this.loadingState.loadSleepEnd(0.3);

        if (this.commonService.checkNoneResponse(response)) {
          this.loginService.logout(MESSAGE_CODE.E90000);
          return;
        } else {
          this.loginUser = response.body;
          this.roleAuth = response.body.class_id;
          this.getListAgendaByRole();
          this.searchChatList("");
          this.getIsUnanswered();
        }
      });
    } else {
      this.roleAuth = this.loginUser.class_id;
      this.getListAgendaByRole();
      this.searchChatList("");
      this.getIsUnanswered();
    }
    forkJoin([
      this.getNoticeDataList(NOTICE_TYPES.MEMBER_NOTICE),
      this.getNoticeDataList(NOTICE_TYPES.SYSTEM_NOTICE),
    ]).subscribe((dataList) => {
      this.listNotice = this.noticeDataList.concat(
        this.platformEventDataList
      ).sort((a: any, b: any) => this.compareNotice(a, b));
    });
  }

  getButtonText(): string {
    return this.roleAuth == '9' ? '一覧に移動' : 'もっと探す';
  }

  public async getListAgendaByRole() {
    switch (this.roleAuth) {
      case ROLES.SCHOOL:
        await this.getListAgendaSolutions();
        await this.getListAgendaNeeds();
        this.isLoading = false;
        break;

      case ROLES.NURSERY:
        await this.getListAgendaNeeds();
        await this.getListAgendaSolutions();
        this.isLoading = false;
        break;

      case ROLES.ADMIN:
        await this.getListAgendaSolutions();
        await this.getListAgendaNeeds();
        await this.getListConsultation();
        this.isLoading = false;
    }
  }

  private getListAgendaSolutions() {
    return new Promise<any>((resolve) => {
      this.loadingState.loadStart(API_URL_GET_AGENDA_SOLUTIONS);

      this.dbOperationService
        .getNoTemplateData(API_URL_GET_AGENDA_SOLUTIONS)
        .subscribe((response) => {
          if (!this.commonService.checkNoneResponse(response)) {
            this.listAgendaSolutions = response.body;
          } else {
            this.listAgendaSolutions = new Array();
          }

          this.loadingState.loadSleepEnd(0.3, API_URL_GET_AGENDA_SOLUTIONS);
          resolve(null);
        });
    });
  }

  private getListAgendaNeeds() {
    return new Promise<any>((resolve) => {
      this.loadingState.loadStart(API_URL_GET_AGENDA_NEEDS);

      this.dbOperationService
        .getNoTemplateData(API_URL_GET_AGENDA_NEEDS)
        .subscribe((response) => {
          if (!this.commonService.checkNoneResponse(response)) {
            this.listAgendaNeeds = response.body;
          } else {
            this.listAgendaNeeds = new Array();
          }

          this.loadingState.loadSleepEnd(0.3, API_URL_GET_AGENDA_NEEDS);
          resolve(null);
        });
    });
  }

  private getListConsultation() {
    return new Promise<any>((resolve) => {
      this.loadingState.loadStart(API_URL_GET_CONSULTATION);

      this.dbOperationService
        .getNoTemplateData(API_URL_GET_CONSULTATION)
        .subscribe((response) => {
          if (!this.commonService.checkNoneResponse(response)) {
            this.listConsultations = response.body;
          } else {
            this.listConsultations = new Array();
          }

          this.loadingState.loadSleepEnd(0.3, API_URL_GET_CONSULTATION);
          resolve(null);
        });
    });
  }

  private getIsUnanswered() {
    this.isUnanswered = false;
    this.dbOperationService
      .getNoTemplateData(API_URL_SEARCH_MATCHED, {}, true)
      .subscribe((response) => {
        if (response.body.notice_count >= 1) {
          this.isUnanswered = true;
        }
      });
  }

  /**
   * search my page chat
   */
  public searchChatList(chatstt) {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_SEARCH_MY_PAGE_CHAT);
    if (!chatstt) {
      chatstt = "";
    }

    // 最近の更新（最近1ヶ月）を取得
    this.dbOperationService
      .getNoTemplateData(API_URL_SEARCH_MY_PAGE_CHAT, {
        status: chatstt,
      })
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 最近の更新（最近1ヶ月）を格納
          this.listChatMypage = response.body;
        } else {
          this.listChatMypage = new Array();
        }
        this.listChatMypageNG = JSON.parse(JSON.stringify(this.listChatMypage))
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_SEARCH_MY_PAGE_CHAT);
      });
  }

  checkUncheckAll(evt) {
    if (evt.checked) {
      this.statusValue = this.statusProgress.map((stt: any) => stt.code);
    } else {
      this.statusValue = [];
    }
    this.searchChatList("");
  }
  public searchChatListCondition() {
    if (this.statusValue.length == 4) {
      this.checkAll = [""];
      this.searchChatList("");
    } else {
      this.checkAll = [];
      this.searchChatList(this.statusValue);
    }
  }

  /**
   *  課題・ソリューション登録(C101)へ遷移する
   * @param agendaKbn 区分 1:課題　2:ソリューション
   */
  public moveC101(agendaKbn: number): void {
    // 課題・ソリューション登録(C101)へ遷移
    this.router.navigate(["pages/platform/c101/new"], {
      queryParams: {
        screenId: "c101",
        agenda_kbn: agendaKbn,
      },
    });
  }

  // /**
  //  * 連携事例(H101)へ遷移する
  //  */
  // public moveH101(): void {
  //   // 連携事例登録(H101)へ遷移
  //   this.router.navigate(['pages/platform/h101/new'], {
  //     queryParams: {
  //       screenId: 'h101',
  //     },
  //   });
  // }

  /**
   * ユーザ管理一覧(B220)へ遷移する
   */
  public moveB220(): void {
    // ユーザ管理一覧(B220)へ遷移
    this.router.navigate(["pages/platform/b220"]);
  }

  /**
   * マッチング依頼一覧(C502)へ遷移する
   */
  public moveC502(): void {
    // マッチング依頼一覧(C502)へ遷移
    this.router.navigate(["pages/platform/c502"]);
  }

  /**
   *事務局(D101)へ遷移する
   */
  public moveD101(): void {
    // 事務局(D101)へ遷移
    this.router.navigate(["pages/platform/d101"]);
  }

  /**
   * イベント申請一覧(E103)へ遷移する
   */
  public moveE103(): void {
    // イベント申請一覧(E103)へ遷移
    this.router.navigate(["pages/platform/e103"]);
  }

  /**
   * 分科会申請一覧(E203)へ遷移する
   */
  public moveE203(): void {
    // 分科会申請一覧(E203)へ遷移
    this.router.navigate(["pages/platform/e203"]);
  }

  public moveC331(agenda_id?: any): void {
    this.router.navigate([`pages/platform/c331/${agenda_id}`]);
  }


  public moveC231(): void {
    this.router.navigate(["pages/platform/c231/"]);
  }

  public moveC241(): void {
    this.router.navigate(["pages/platform/c241/"]);
  }

  public moveC341(agenda_id?: any): void {
    this.router.navigate([`pages/platform/c341/${agenda_id}`]);
  }

  public moveC601(matchId): void {
    this.router.navigate([`pages/platform/c601/${matchId}`]);
  }

  public moveM701(): void {
    this.router.navigate([`pages/platform/master/m701`]);
  }
  cancelConfirm(event) {
    this.listChatMypage.map((chat, index) => {
      event == chat.match_id ? (chat.match_status = this.listChatMypageNG[index].match_status) : chat.match_status;
    });
  }
  public changeStatus(event, matchId) {
    if (event.value == CHATSTATUSES.END.code) {
      this.confirmRejectMatchDialogComponent.updateMatchStatus(
        API_URL_UPDATE_MATCH_STATUS_MY_PAGE,
        matchId,
        CHATSTATUSES.END.code
      );
    }
    if (event.value == CHATSTATUSES.ADJUSTMENT.code) {
      this.confirmRejectMatchDialogComponent.updateMatchStatus(
        API_URL_UPDATE_MATCH_STATUS_MY_PAGE,
        matchId,
        CHATSTATUSES.ADJUSTMENT.code
      );
    }
  }
  public changeStatusSuccess(event) {
    // this.listChatMypage.map((chat, index) => {
    //   if (chat.match_id == event) {
    //     this.listChatMypage[index].match_id = CHATSTATUSES.END.code;
    //   }
    // });
    this.listChatMypageNG = JSON.parse(JSON.stringify(this.listChatMypage))
    this.searchChatListCondition();
  }

  public setClassStatus(matchStatus: any) {
    let classActiveColor = "";
    switch (matchStatus) {
      case CHATSTATUSES.REQUEST.code:
        classActiveColor = "yellow-color";
        break;
      case CHATSTATUSES.ADJUSTMENT.code:
        classActiveColor = "green-color";
        break;
      case CHATSTATUSES.DECISION.code:
        classActiveColor = "blue-color";
        break;
      case CHATSTATUSES.IMPLEMENTED.code:
        classActiveColor = "bg-red-color";
        break;

      default:
        classActiveColor = "text-default-color";
        break;
    }

    return classActiveColor;
  }

  public setClassStatusDropdown(matchStatus) {
    let classActiveColor = "";
    switch (matchStatus) {
      case CHATSTATUSES.ADJUSTMENT.code:
        classActiveColor = "green-dropdown-color";
        break;
      case CHATSTATUSES.REQUEST.code:
        classActiveColor = "yellow-dropdown-color";
        break;
      case CHATSTATUSES.DECISION.code:
        classActiveColor = "blue-dropdown-color";
        break;
      case CHATSTATUSES.IMPLEMENTED.code:
        classActiveColor = "red-dropdown-color";
        break;
      case CHATSTATUSES.END.code:
        classActiveColor = "default-dropdown-color";
        break;
      default:
        break;
    }
    return classActiveColor;
  }

  public moveScreenByMatchType(match_id: string, match_type: string, match_ns_id?: string) {
    this.matchId = match_id;
    this.agendaId = match_ns_id;
    if (match_type == MATCH_TYPE.AGENDA_SOLUTION) {
      this.isShowDialogC331 = true;
    } else if (match_type == MATCH_TYPE.AGENDA_NEED) {
      this.isShowDialogC341 = true;
    }
  }
  public closeDialogC331(openDialog: boolean): void {
    this.isShowDialogC331 = openDialog;
  }
  public closeDialogC341(openDialog: boolean): void {
    this.isShowDialogC341 = openDialog;
  }

  public openMemoDialog(chatId: any, memo: string): void {
    // 内閣府承認ダイアログ表示
    this.memoDialogComponent.openMemoDialog(chatId, memo);
  }

  closeMemoDialog(openDialog: boolean): void {
    this.searchChatListCondition();
  }

  /**
   * check login mêmber
   * @param memberId
   * @returns
   */
  isLoginMember(memberId: string) {
    return this.loginUser.member_id === memberId;
  }

  /**
   * check overflow of element
   * @param el html element of list 
   * @returns 
   */
  isOverflow(el: HTMLElement): boolean {
    const curOverflow = el.style.overflow;
    if (!curOverflow || curOverflow === "visible")
      el.style.overflow = "hidden";
    const isOverflowing = el.clientWidth < el.scrollWidth
      || el.clientHeight < el.scrollHeight;
    el.style.overflow = curOverflow;
    return isOverflowing;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  number(value: string) {
    return Number(value);
  }

  reloadMatchingList() {
    this.searchChatList("");
  }

  getListStatusChange(status: any, type: any) {
    switch (status) {
      case CHATSTATUSES.REQUEST_PROPOSAL.code:
        if (type === '1') {
          return [CHATSTATUSES.REQUEST, CHATSTATUSES.ADJUSTMENT, CHATSTATUSES.END];
        }
        return [CHATSTATUSES.PROPOSAL, CHATSTATUSES.END];
      case CHATSTATUSES.ADJUSTMENT.code:
        return [CHATSTATUSES.ADJUSTMENT, CHATSTATUSES.END];
      case CHATSTATUSES.DECISION.code:
        return [CHATSTATUSES.ADJUSTMENT, CHATSTATUSES.DECISION];
      case CHATSTATUSES.IMPLEMENTED.code:
        return [CHATSTATUSES.IMPLEMENTED, CHATSTATUSES.END];
      case CHATSTATUSES.END.code:
        return [CHATSTATUSES.ADJUSTMENT, CHATSTATUSES.END];
      case CHATSTATUSES.REQUEST.code:
        return [CHATSTATUSES.REQUEST, CHATSTATUSES.ADJUSTMENT, CHATSTATUSES.END]
      default:
        return []
    }
  }
  /**
   * お知らせ情報リスト取得
   * @param information_kbn お知らせ区分(1:お知らせ 2:PF主催イベント)
   */
  private getNoticeDataList(information_kbn: string) {
    return new Promise<any>((resolve) => {
      // お知らせ一覧を取得
      this.dbOperationService
        .getNoTemplateData(
          INFORMATION_LIST,
          { information_kbn: information_kbn },
          true
        ).subscribe((response) => {
          // お知らせ情報
          if ('1' == information_kbn) {
            if (!this.commonService.checkNoneResponse(response)) {
              // お知らせ一覧を格納
              this.noticeDataList = response.body;
            } else {
              this.noticeDataList = new Array();
            }
          }

          // システムに関するお知らせ情報
          if ('2' == information_kbn) {
            if (!this.commonService.checkNoneResponse(response)) {
              // システムに関するお知らせ一覧を格納
              this.platformEventDataList = response.body;
            } else {
              this.platformEventDataList = new Array();
            }
          }
          resolve(response);
        });
    });
  }

  public compareNotice(a: any, b: any) {
    let publishDateResult = new Date(b.publishe_start).getTime() - new Date(a.publishe_start).getTime();
    if (publishDateResult != 0) {
      return publishDateResult;
    } else {
      return new Date(b.create_datetime).getTime() - new Date(a.create_datetime).getTime();
    }
  }

  getManualSchool() {
    window.open("https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB/%E4%B8%8B%E9%96%A2%E5%B8%82_%E3%81%BE%E3%81%A1%E3%82%B9%E3%82%AF%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E3%83%9E%E3%83%8B%E3%83%A5%E3%82%A2%E3%83%AB%EF%BC%88%E5%AD%A6%E6%A0%A1%E3%83%A6%E3%83%BC%E3%82%B6%E3%83%BC%EF%BC%89.pdf")
  }

  public openConsultationDialog(item: any): void {
    this.consultationDialogComponent.openConsultationDialog(item?.consultation_contente, { contente: item?.consultation_contente, type: "detail_c502" });
  }

  removeParentheses(text: string | undefined | null): string {
    if (!text) return '';
    return text.replace(/\（.*?\）/g, '').trim();
  }
}
